<template>
  <div>
    <label class="text-background-fg/87 mb-2 block text-xs font-semibold">
      {{ label }}
    </label>
    <BaseInputText
      v-model="dateModel"
      type="date"
      pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
      input-class="text-xs"
    />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue: string | undefined;
  label?: string;
}>();

const emit = defineEmits<{
  (event: "update:modelValue", value: typeof props.modelValue): void;
}>();

const dateModel = ref<string>("");

whenever(
  () => props.modelValue,
  (value) => {
    dateModel.value = value || "";
  },
  {
    immediate: true,
  },
);

watch(
  () => dateModel.value,
  (value) => {
    emit("update:modelValue", value || undefined);
  },
);
</script>
